import { render, staticRenderFns } from "./EditaRedefinicionFila.vue?vue&type=template&id=6bfdbf15"
import script from "./EditaRedefinicionFila.vue?vue&type=script&lang=js"
export * from "./EditaRedefinicionFila.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports